import { render, staticRenderFns } from "./NuevaODTGrupos.vue?vue&type=template&id=44bf5310&scoped=true&"
import script from "./NuevaODTGrupos.vue?vue&type=script&lang=js&"
export * from "./NuevaODTGrupos.vue?vue&type=script&lang=js&"
import style0 from "./NuevaODTGrupos.vue?vue&type=style&index=0&id=44bf5310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bf5310",
  null
  
)

export default component.exports